import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import { fetchSocialMediaGetAll } from "../../redux/slices/socialMediaGetAllSlice";
import { URL } from "../../api";
import { fetchMenuGroupGetAll } from "../../redux/slices/menuGroupGetAllSlice";
import { fetchSettingsGet } from "../../redux/slices/settingsGetSlice";

const Footer = () => {
  const { t } = useTranslation();
  const lang = useSelector((state) => state.lang.lang);
  const socialMedias = useSelector((state) => state.socialMediaGetAll.data);
  const menuGroups = useSelector((state) => state.menuGroupGetAll.data);
  const settings = useSelector((state) => state.settingsGet.data);
  const dispatch = useDispatch()

  const getData = async () => {
    await dispatch(fetchMenuGroupGetAll())
    await dispatch(fetchSocialMediaGetAll())
    await dispatch(fetchSettingsGet())
  }

  useEffect(() => { getData() }, [dispatch])

  const IsTargetBlank = (text) => {
    if (text?.search("/") !== -1 || text.search("No:") !== -1 || text.search("no:") !== -1) {
      return true;
    }
  }

  return (
    <div className="footer">
      <Row className="footer-top">
        <Col xs={12} sm={6} md={3}>

        </Col>
        <Col xs={12} sm={0} md={3}></Col>
        <Col xs={12} sm={3} md={6}>
          <div className="social-media-icon">
            {
              socialMedias?.map((item, index) => {
                return (
                  <a href={`${item?.slug?.tr}`} target="_blank" rel="noopener noreferrer" key={index}>
                    <img src={`${URL}${item?.files[0]}`} alt={item?.title[lang]} loading="lazy" />
                  </a>
                )
              })
            }
          </div>
        </Col>
      </Row>
      <hr />
      {menuGroups ? <Row className="footer-links">
        <Col xs={12} sm={3} md={3} className="footer-contact">
          <div className="logo textAlignCenter">
            <Link to="/">
              <img src={`${URL}${settings?.darkLogo}`} alt="Logo" loading="lazy" />
            </Link>
          </div>
        </Col>
        <Col xs={12} sm={3} md={3} className="footer-contact">
          <h4>{menuGroups[1]?.title[lang]}</h4>
          {
            (menuGroups[1]?.menus ? [...menuGroups[1].menus] : [])
              .sort((a, b) => a.sort - b.sort)
              .map((item, index) => {
                return (
                  <Link
                    to={lang === "tr" ? `/${item?.slug?.tr}` : `/${item?.slug?.en}`}
                    className={({ isActive }) => (isActive ? "active" : "")}
                    key={index}
                  >
                    <p>{item?.title[lang]}</p>
                  </Link>
                )
              })
          }
        </Col>
        <Col xs={12} sm={3} md={3} className="footer-contact">
          <h4>{menuGroups[2]?.title[lang]}</h4>
          {
            (menuGroups[2]?.menus ? [...menuGroups[2].menus] : [])
              .sort((a, b) => a.sort - b.sort)
              .map((item, index) => {
                return (
                  <Link
                    to={lang === "tr" ? `/${item?.slug?.tr}` : `/${item?.slug?.en}`}
                    className={({ isActive }) => (isActive ? "active" : "")}
                    key={index}
                  >
                    <p>{item?.title[lang]}</p>
                  </Link>
                )
              })
          }
        </Col>
        <Col xs={12} sm={3} md={3} className="footer-contact">
          <h4>{menuGroups[3]?.title[lang]}</h4>
          {
            (menuGroups[3]?.menus ? [...menuGroups[3].menus] : [])
              .sort((a, b) => a.sort - b.sort)
              .map((item, index) => {
                return (
                  <div key={index} className="d-flex justify-content-start align-items-center">
                    <img src={`${URL}${item.files[0]}`} alt="" className="h20 contain mr-2" loading="lazy" />
                    <Link
                      target={IsTargetBlank(item?.slug[lang]) ? "_blank" : ""}
                      to={lang === "tr" ? `${item?.slug?.tr}` : `${item?.slug?.en}`}
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <p>{item?.title[lang]}</p>
                      <p>{item?.specialField1[lang]}</p>
                    </Link>
                  </div>
                )
              })
          }
        </Col>
      </Row> : null}
      <hr />
      <div className="footer-bottom">
        <p>{t("copyright")}{new Date().getFullYear()}</p>
      </div>
    </div>
  );
};

export default Footer;
